var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.editorConfig)?_c('vue-ueditor-wrap',{staticClass:"edui-LMS",attrs:{"config":_vm.editorConfig},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }